module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm-2 20.524c0 1.276-.754 1.688-1.77.926l-5.46-4.152c-.494-.37-.746-.852-.77-1.34v-.094c.008-.484.242-.964.732-1.33l5.498-4.15c1.016-.762 1.77-.352 1.77.92v9.22zm10 0c0 1.276-.754 1.688-1.77.926l-5.46-4.152c-.494-.37-.746-.852-.77-1.34v-.094c.008-.484.242-.964.732-1.33l5.498-4.15c1.016-.762 1.77-.352 1.77.92v9.22z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/previous-4.js
// module id = 1357
// module chunks = 14